<template>
    <div v-if="settings">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.key" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.apiKey" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Password</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.apiPassword" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Endpoint</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.apiEndpoint" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Hmac Secret</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.hmacSecret" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label"></label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <button @click="loadAvailableGamesAsync();" class="button is-small is-link" :disabled="availableGamesLoading">Load Available Games</button>
                        <button @click="syncGamesAsync();" class="button is-small is-link">Sync Games</button>
                        <button @click="clearGamesCacheAsync();" class="button is-small is-link">Clear Games Cache</button>
                    </p>
                    <!--<div v-if="availableGames.length" class="field my-1">
                        <p class="control">
                            <div style="max-width: 800px; height: 200px; overflow: auto; overflow-x: hidden; margin: 1em 0; background: #fff; color: #000;">
                                {{ availableGames }}
                            </div>
                        </p>
                    </div>-->
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save();" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Games</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div>
                            <draggable :list="settings.games">
                                <div v-for="game of settings.games" class="game-id">
                                    <div class="field has-addons">
                                        <p class="control">
                                            <span class="icon is-medium">
                                                <i class="fas fa-grip-vertical"></i>
                                            </span>
                                        </p>
                                        <p class="control">
                                            <input v-model="game.id" class="input is-small" type="text" placeholder="Id" disabled />
                                        </p>
                                        <p class="control">
                                            <input v-model="game.name" class="input is-small" type="text" placeholder="Name" disabled />
                                        </p>
                                        <p class="control">
                                            <span class="tag button-tag"
                                                :class="{'is-success': game.isEnabled}"
                                                @click="game.isEnabled = true;">enabled</span>
                                            <span class="tag button-tag"
                                                :class="{'is-danger': !game.isEnabled}"
                                                @click="game.isEnabled = false;">disabled</span>
                                        </p>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import softgamingsService from "../../../../services/softgamings.service";

    export default {
        name: "client-settings-softgamings",
        components: { draggable },
        data: () => ({
            settings: null,
            availableGames: [],
            availableGamesLoading: false
        }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            }
        },
        async mounted() {
            this.loadSettingsAsync();
        },
        methods: {
            async loadSettingsAsync() {
                this.settings = await softgamingsService.getSettingsByClientAsync(this.clientId);
                console.log('loadSettingsAsync', this.settings);
            },
            save() {
                softgamingsService.saveAsync(this.clientId, this.settings);
            },
            async loadAvailableGamesAsync() {
                this.availableGamesLoading = true;
                const games = await softgamingsService.getAvailableGamesAsync(this.clientId, this.settings);
                this.availableGames.push(...games);

                
                const settingsGameMap = this.settings.games.reduce((acc, item) => { acc[item.id] = item; return acc; }, {})
                console.log('loadAvailableGamesAsync settingsGameMap', settingsGameMap);

                const settingsGames = games.map(g => ({
                    id: g.id,
                    name: g.names.en,
                    isEnabled: settingsGameMap[g.id] ? settingsGameMap[g.id].isEnabled : true
                }));
                this.settings.games.splice(0, this.settings.games.length, ...settingsGames);

                console.log('loadAvailableGamesAsync', this.settings);
                this.availableGamesLoading = false;
            },
            syncGamesAsync() {
                softgamingsService.syncGamesAsync(this.clientId, this.settings);
            },
            clearGamesCacheAsync() {
                softgamingsService.clearGamesCacheAsync(this.clientId, this.settings);
            }
        }
    };
</script>

<style lang="scss">
    .game-id {
        margin-bottom: 0.32rem;
        padding: 0.4rem 0.8rem;
        max-width: 800px;
        border: 1px solid #666;
        border-radius: 0.2rem;
        background-color: #333;
        .icon

    {
        margin-right: 0.2rem;
    }

    div {
        width: 100%;
    }

    input {
        width: 352px;
    }
    }
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/softgamings.vue